import type { AudioPlayer } from './types';

/**
 * No-op `AudioPlayer` used during SSR / typecheck builds and as a fallback
 * whenever the sprite has no `src` configured. Keeps the consumer hook
 * total — features always get a callable `play`.
 */
export const noOpPlayer: AudioPlayer = {
  play() {
    /* no-op */
  },
};
